<template>
  <acclaro-modal v-if="referenceDetailsModal.show" @close="referenceDetailsModal.show = false">
    <div slot="header" class="account-references-modal-section">
      <div class="flex account-references-modal-header">
        <div>
          <h1>{{modalHeader}}</h1>
        </div>
        <div>
          <i @click="closeReferenceModal" class="acclaro-icon ai-close clickable"></i>
        </div>
      </div>
      <span v-html="modalSubHeader"></span>
    </div>
    <div slot="body" class="account-references-modal-section account-references-modal-body">
      <fieldset class="reference-form-input-container has-background">
        <div>
          <label class="taf-label bold">Name<span class="required" id="name-required">*</span></label>
          <acclaro-input v-model="referenceModalName" placeholder=""/>
        </div>
      </fieldset>
      <fieldset class="reference-form-input-container has-background">
        <div>
          <label class="taf-label bold">Details</label>
          <acclaro-text-editor
            v-model="referenceModalDetails"
            id="references-editor"
            class="reference-acclaro-text-editor"
            :char-limit="maxChars" />
        </div>
      </fieldset>
    </div>
    <div slot="footer" class="account-references-modal-footer">
      <div class="flex" style="justify-content: space-between;">
        <div>
          <input type="checkbox"
                 v-if="showPrivateOption"
                 v-model="referenceModalIsPrivate"/>
          <span v-if="showPrivateOption">Private</span>
        </div>
        <div class="flex">
          <button class="acclaro-hollow-btn reference-form-cancel" @click="closeReferenceModal">Cancel</button>
          <button class="bbutton" @click="saveReference">Save</button>
        </div>
      </div>
    </div>
  </acclaro-modal>
</template>

<script>

import {mapActions, mapMutations, mapState} from "vuex";
import AcclaroInput from "../Micro-Components/Acclaro-Input/Acclaro-Input";
import AcclaroModal from './../Modal/acclaro-modal.vue';
import Autolinker from 'autolinker';
import './references.scss'

// will help handle link inputs
// class CustomLink extends Link {
//
//   static sanitize (url) {
//     let value = super.sanitize(url);
//     if (value) {
//       for (let i = 0; i < this.PROTOCOL_WHITELIST.length; i++)
//         if (value.startsWith(this.PROTOCOL_WHITELIST[i]))
//           return value;
//
//       return `https://${value}`;
//     }
//     return value;
//   }
// }


export default {
  name: "AccountReferencesForm",
  props: ['reference'],
  components: {AcclaroInput, AcclaroModal},
  data () {
    return {
      'maxChars': 5000
    };
  },
  computed: {
    ...mapState('AccountReferencesStore', [
      'selectedAccount',
      'searchTerm',
      'stats',
      'referenceDetailsModal',
    ]),
    ...mapState('AuthStore', [
      'user',
      'account'
    ]),
    modalHeader(){
      if (this.referenceDetailsModal.mode === 'duplicate'){
        return "Duplicate Reference"
      } else {
        return `Add Account Reference for ${this.selectedAccount && this.selectedAccount.name}`
      }
    },
    modalSubHeader(){
      if (this.referenceDetailsModal.mode === 'duplicate'){
        return "Make your edits and click <b>Save.</b>"
      } else {
        return "<p>Account References are visible to everyone in your organization unless you make them private.</p>"
      }
    },
    showPrivateOption () {
      return this.selectedAccount && this.selectedAccount.id === this.account.id;
    },
    referenceModalName: {
      get () {
        return this.$store.state.AccountReferencesStore.referenceDetailsModal.name;
      },
      set (value) {
        this.updateReferenceModalName(value);
      }
    },
    referenceModalIsPrivate: {
      get () {
        return this.$store.state.AccountReferencesStore.referenceDetailsModal.is_private;
      },
      set (value) {
        this.updateReferenceModalIsPrivate(value);
      }
    },
    referenceModalAccountId: {
      get () {
        return this.$store.state.AccountReferencesStore.referenceDetailsModal.account_id;
      },
      set (value) {
        this.updateReferenceModalAccountId(value);
      }
    },
    referenceModalDetails: {
      get () {
        return this.$store.state.AccountReferencesStore.referenceDetailsModal.details;
      },
      set (value) {
        let autoLinked = Autolinker.link(value, {
          newWindow: true,
          urls: true
        });
        this.updateReferenceModalDetails(autoLinked);
      }
    },
    modalCharCount () {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = this.referenceModalDetails;
      const content = tmp.textContent || tmp.innerText || "";
      return content.length;
    }
  },
  methods: {
    ...mapMutations('AccountReferencesStore', [
      'updateReferenceModalShow',
      'updateReferenceModalReferenceId',
      'updateReferenceModalName',
      'updateReferenceModalDetails',
      'updateReferenceModalIsPrivate',
      'updateReferenceModalMode',
      'clearReferenceModal'
    ]),
    ...mapActions('AccountReferencesStore', [
      'postReference',
      'patchReference',
    ]),
    closeReferenceModal () {
      this.clearReferenceModal();
      this.updateReferenceModalShow(false);
    },
    saveReference () {
      if (!this.modalCharCount > this.maxChars) {
        return this.alertMaxChars();
      }

      if (!this.referenceModalName) {
        return alert('Reference name is required.');
      }

      if (this.referenceDetailsModal.mode === 'create' || this.referenceDetailsModal.mode === 'duplicate') {
        this.postReference(this.user.id);
      }
      else if (this.referenceDetailsModal.mode === 'edit') {
        this.patchReference({
          "reference_id": parseInt(this.referenceDetailsModal.referenceId),
          "name": this.referenceModalName,
          "details_html": this.referenceModalDetails,
          "is_private": this.referenceModalIsPrivate,
          "account_id": this.referenceModalAccountId,
        });
      }
    },
    alertMaxChars () {
      alert(`Cannot have more than ${this.maxChars} characters in a reference.`);
    },
  }
};
</script>

<style scoped>

.reference-form-input-container {
  padding-bottom: 10px;
}

.reference-hidden-char-count {
  height: 1px;
  overflow: hidden;
  opacity: 0;
  margin: 0;
  padding: 0;
}

.reference-acclaro-text-editor {
  width: 100%;
  max-width: 100%;
}

.reference-form-cancel {
  max-width: 100px;
}

.account-references-modal-section {
  border-bottom: 1px solid #D0D0D0;
  padding: 20px
}

.account-references-modal-header {
  justify-content: space-between;
}

.account-references-modal-footer {
  padding: 20px
}

.account-references-modal-body {
  background: #FAFAFA;
}

#name-required {
  font-size: 14px !important;
}

</style>
